import type { ActionTree, ActionContext } from 'vuex'
import type { RootState } from '@/store'
import type { UserState } from './types'
import type { UserSetting } from '@/types/user'
import { USER_MUTATIONS, USER_ACTIONS } from './types'

interface IUserActions extends ActionTree<UserState, RootState> {
  [USER_ACTIONS.SET_SETTINGS](
    context: ActionContext<UserState, RootState>,
    userSettings: UserSetting
  ): void
  [USER_ACTIONS.UPDATE_SETTINGS](
    context: ActionContext<UserState, RootState>,
    userSettings: UserSetting
  ): void
}

const actions: IUserActions = {
  [USER_ACTIONS.SET_SETTINGS]({ commit }, userSettings) {
    commit(USER_MUTATIONS.SET_SETTINGS, userSettings)
  },
  [USER_ACTIONS.UPDATE_SETTINGS]({ commit }, userSettings) {
    commit(USER_MUTATIONS.UPDATE_SETTINGS, userSettings)
  }
}

export default actions
